export default __webpack_public_path__ + "static/media/login.26463742.svg";